<div [ngClass]="{ sidebar: true, 'sidebar-collapsed': isSidebarCollapsed() }">
  <div class="sidebar-header">
    <button class="sidebar-toggle-btn" (click)="onSidebarToggle()">
      @if (!isSidebarCollapsed()) {
        <i class="bi bi-chevron-left"></i>
        Amaga
      } @else {
        <i class="bi bi-chevron-right"></i>
      }
    </button>
  </div>

  <div class="sidebar-menu">
    <ul class="sidebar-menu-list">
      @for (item of sidebarMenuItems(); track $index) {
        <ng-container *rolePermissions="item.roles">
          <ng-container *featureFlags="item.features">
            <li
              app-sidebar-tree
              class="sidebar-menu-item sidebar-tree-first-level"
              [ngClass]="{
                'sidebar-tree': true,
                'has-children': item.isDropdown,
                'sidebar-tree-open': item.isOpen,
                'sidebar-collapsed': isSidebarCollapsed(),
              }"
              [sidebarNode]="item"
              [isSidebarCollapsed]="isSidebarCollapsed()"
              [level]="1"
            ></li>
          </ng-container>
        </ng-container>
      }
    </ul>
  </div>
</div>
